(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["product-recommendations-carousel"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-v2');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          $('.product-recommendations-v2 .grid').addClass("slick-target-element");
          $('.product-recommendations-v2 .grid').removeClass("grid grid--uniform");
          $('.product-recommendations-v2 .grid__item').removeClass("grid__item grid-product small--one-half medium-up--one-quarter");
          $('.product-recommendations-v2 .slick-target-element').slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          speed: 500,
          arrows: true,
          dots: false,
          responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  arrows: true,
                  dots: false
                }
              }
            ]
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations-v2');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
      })();
